import { render } from "./Agentbots.vue?vue&type=template&id=de078010"
import script from "./Agentbots.vue?vue&type=script&lang=js"
export * from "./Agentbots.vue?vue&type=script&lang=js"

import "./Agentbots.vue?vue&type=style&index=0&id=de078010&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__